<template>
  <div class="consult-complaiont">
    <van-form validate-first  @submit="onSubmit">
      <div class="para-title">咨询与投诉内容</div>
      <van-cell-group>
        <van-cell class="title-font" title="类型" required/>
        <van-radio-group v-model="consultType" direction="horizontal" class="complain-class">
          <van-radio class="complain-item" name="建议">建议</van-radio>
          <van-radio class="complain-item" name="投诉">投诉</van-radio>
          <van-radio class="complain-item" name="其他">其他</van-radio>
        </van-radio-group>
        <van-cell class="title-font" title="主题" required/>
        <van-field v-model="mainTitle" placeholder="请输入主题" class="input-border-class" :rules="[{ required: true, message: '请填写主题' }]"/>
        <van-cell class="title-font" title="内容"/>
        <van-field
          v-model="content"
          type="textarea"
          :autosize="{maxHeight: 150, minHeight: 150}"
          :placeholder="placeholder"
          class="textarea-border-class"
        />
        <van-cell class="title-font" title="附件"/>
        <div class="file-upload">
          <div class="file-upload-wrapper">
            <div
              class="file-upload-preview"
              v-for="(item, index) of list"
              :key="index"
            >
              <div>
                <van-image
                  width="55"
                  height="55"
                  class="pdf-icon"
                  :src="item.fileUrl"
                />
                <van-icon
                  class="delete-icon"
                  :name="require('@/assets/img/projectAppoint/delete.png')"
                  @click="deleteFile(item, index)"
                ></van-icon>
              </div>
            </div>
            <van-uploader
              :after-read="onAfterRead"
              :before-read="onBeforeRead"
              max-count="1"
              accept=""
              id="android-upload"
            >
              <van-button class="upload-btn">
                <van-icon name="plus" size="40" color="#DDDDDD"
              /></van-button>
            </van-uploader>
          </div>
        </div>
        
        <!-- <van-cell class="upload-border-class">
          <template #right-icon>
            <div class="img-upload">
              <van-uploader
                :after-read="onAfterRead"
                :before-read="onBeforeRead"
                accept=""
                multiple
              >
                <van-image
                  :src="require('@/assets/img/projectAppoint/file_upload.png')"
                />
              </van-uploader>
            </div>
          </template>
        </van-cell>
        <div class="file-upload-box ">
          <div class="file-upload-item" v-for="(item, index) in list" :key="index">
            <div class="file-upload-content">
              <div class="file-upload-name">{{ item.fileName }}</div>
            </div>
            <van-icon
              v-if="item.fileStatus == 1"
              class="delete-icon"
              :name="require('@/assets/img/projectAppoint/delete.png')"
              @click="deleteFile(item, index)"
            ></van-icon>
          </div>
        </div> -->
      </van-cell-group>
      <div class="para-title">基本资料</div>
      <van-cell-group style="padding: 3vw 0;">
        <div class="basic-info-box">
          <van-field v-model="userName" label="联系人" placeholder="请输入联系人" required/>
          <van-field v-model="phoneNum" label="手机号码" type="tel" name="phoneNumValidator" placeholder="请输入手机号码" required :rules="[{  validator:phoneNumValidator, message: '请填写正确的手机号' }]"/>
          <van-field v-model="emailBox" label="电子邮箱" name="mailBoxValidator" placeholder="请输入电子邮箱" required :rules="[{ validator:mailBoxValidator, message: '请填写正确的电子邮箱地址' }]"/>
          <van-field v-model="liveAddress" label="联系地址" placeholder="请输入单位地址/联系地址"/>
        </div>
      </van-cell-group>
      <div style="padding: 5vw 0 20vw 0">
        <van-button block type="info" class="submit-btn" native-type="submit">
          提交
        </van-button>
        <!-- <van-button block class="submit-btn" @click.stop="submit">
          提交
        </van-button> -->
      </div>
    </van-form>
  </div>
</template>

<script>
import api from '@/utils/api/consultComplaiont'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  components: {},
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      consultType: '建议',// 类别
      content: '',// 内容
      code: '',
      placeholder: '请填写具体内容',
      tips: true,
      mainTitle:"",// 主题
      fileUpload:'',// 附件
      uploadFiles:[],// 上传附件数组
      userName:"",// 联系人
      phoneNum:"",// 手机号码
      emailBox:"",// 电子邮箱
      liveAddress:"",// 联系地址
      fileList:[],// 附件数组
      fileListUrl:[],// 附件文件服务器路径数组
      list:[],// 上传附件数组
      listValue: [],
      accept:".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip,.rar,.gif",// 允许上传类型
      userInfo:{},// 用户信息
      serialNo:"",//

      value1: '',
      value2: '',
      value3: '',
      pattern: /\d{6}/,
    }
  },
  watch: {
  },
  computed: {
    navTitle() {
      return '咨询与投诉'
    }
  },
  methods: {
    mailBoxValidator(val){
      return /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/.test(val)
    },
    phoneNumValidator(val){
      return /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$/.test(val);
    },
    // 文件读取后的回调函数
    onAfterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (!(file instanceof Array)) {
        this.upload(file)
      } else {
        file.forEach(item => {
          this.upload(item)
        })
      }
      this.$emit('onAfterRead', file)
    },
    // 文件读取前的回调函数
    onBeforeRead(file) {
      // console.log(file)
      // 黑名单文件判断(固定9种类型)
      if (/.(jsp|jspx|jspf|sh|html|htm|shtml|js|htaccess)$/i.test(file.name)) {
        this.$toast('文件类型不支持')
        return false
      }
      // 文件类型判断(由后台配置传入)
      if (this.accept && this.accept != '*') {
        const nameArr = file.name.split('.')
        const type = '.' + nameArr[nameArr.length - 1]
        if (!this.accept.includes(type)) {
          this.$toast('文件类型不匹配')
          return false
        }
      }
      this.$emit('onBeforeRead', file)
      return true
    },
    upload(file) {
      const params = new FormData()
      // console.log('file:', file)
      // console.log('fileSize:', this.getSize(file.file.size))
      if(file.file.size >  30 * 1024 * 1024 * 1024){// 上传文件限制大小，不能大于30m
      this.$toast.fail('上传文件不能大于30MB')
        return 
      }

      let data = {
        fileName: file.file.name,
        fileSize: this.getSize(file.file.size),
        // fileIcon: this.getType(file.file.name),
        fileStatus: 0,
        fileComplete: 0,
        fileUrl:""
      }


      this.list.push(data)
      // console.log('list', this.list)
      params.append('file', file.file)

      api
        .consultUpload(params)
        .then(res => {
          console.log("upload res:",res);
          if(res.code == 0){
            // const dataRes = res.data[0];
            // this.fileList.push(res.data[0])
            // let data = res.data
            // if(data.length > 0){
            //   for(let i = 0; i < data.length; i++){
            //     // console.log('data[i]:',data[i]);
            //     this.fileListUrl.push(data[i].fileUrl)
            //     // console.log("this.fileListUrl[i]:",this.fileListUrl[i]);
            //   }
            // }
            // debugger
            const dataRes = res.data[0];
            if (dataRes) {
              let fileData = {
                FJNAME: dataRes.fileName,
                FJURL: dataRes.fileUrl,
              };
              this.fileListUrl.push(dataRes.fileUrl)
              console.log("--res", res);
              this.$set(data, "fileStatus", 1);
              this.$set(data, "fileUrl", dataRes.fileUrl);
              this.listValue.push(fileData);
              // console.log("this.fileListUrl:",this.fileListUrl);
              this.$toast.success("附件上传成功")
            }
          }
        })
        .catch(err => {
          this.$toast.success('提交失败')
        })
    },
    onSubmit() {
      let params = {}
      params.QSTITLE = this.mainTitle
      params.QSTYPE = this.consultType
      params.SJFSD = ''// 可以为空
      params.LXR = this.userName

      params.LXDH = this.phoneNum
      params.Captcha = ''// 可以为空
      params.EMAIL = this.emailBox
      params.LXDZ = this.liveAddress

      params.CONTENT = this.content
      params.FJ = this.fileListUrl
      params.USERID = this.userInfo.RID
      // console.log("submit params:",params);
      api
        .submitQs(params)
        .then(res => {
          //返回上一级，小程序返回是不一样的
          if (window.__wxjs_environment === 'miniprogram') {
            //提示完再返回
            this.$toast.success({
              message: '提交成功',
              onClose: () => {
                wx.miniProgram.navigateBack({
                  delta: 1
                })
              }
            })
          } else {
            this.$toast.success('提交成功')
            this.$router.go(-1)
          }
          console.log(res)
        })
        .catch(err => {
          this.$toast.success('提交失败')
        })
    },
    // 计算文件大小
    getSize(fileSize) {
      let size = ''
      if (fileSize < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = fileSize.toFixed(2) + 'B'
      } else if (fileSize < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (fileSize / 1024).toFixed(2) + 'KB'
      } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (fileSize / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        // 其他转化成GB
        size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }

      const sizeStr = size + '' // 转成字符串
      const index = sizeStr.indexOf('.') // 获取小数点处的索引
      const dou = sizeStr.substr(index + 1, 2) // 获取小数点后两位的值
      if (dou == '00') {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size
    },
    deleteFile(item, i) {
      this.list.splice(i, 1);
      this.listValue.splice(i,1)
      this.$emit("input", this.listValue);
    },
  },
  created() {},
  mounted() {
    this.userInfo = this.$store.state.userInfo
    this.userName = this.userInfo.LXR
    this.phoneNum = this.userInfo.mobilePhone
    this.emailBox = this.userInfo.mailBox

  }
}
</script>
<style lang="scss" scoped>
.consult-complaiont {
  .para-title{
    padding: 0px 3vw;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    height: 10vw;
    line-height: 10vw;
  }
  .file-upload {
    padding:5vw 3vw;
    .material-selection {
      font-size: 14px;
      font-weight: 500;
      color: #1d84ff;
    }
    .file-upload-content {
      font-size: 11px;
      font-weight: 500;
      color: #999999;
      margin-bottom: 12px;
    }
    .file-upload-wrapper {
      display: flex;
      flex-wrap: wrap;
      .file-upload-preview {
        width: 55px;
        height: 55px;
        margin-right: 20px;
        position: relative;
        border: 1px solid #dddddd;
        text-align: center;
        .delete-icon {
          position: absolute;
          top: 0;
          right: 0;
          -webkit-transform: translate(50%, -50%);
          transform: translate(50%, -50%);
          width: 14px;
          height: 14px;
        }
        .pdf-icon {
          width: 28px;
          height: 100%;
        }
      }
    }
    .upload-btn {
      width: 55px;
      height: 55px;
    }
  }
   .file-upload-box {
    display: flex;
    flex-direction: column;
    .file-upload-item {
      display: flex;
      align-items: center;
      padding: 20px 0px;
      border-bottom: 1px solid #f1f3f6;
      .file-upload-icon {
        width: 29px;
        height: 32px;
      }
      .file-upload-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-left: 20px;
        padding-right: 20px;
        .file-upload-name {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-bottom: 8px;
        }
        .file-upload-size {
          font-size: 13px;
          font-weight: 500;
          color: #999999;
        }
        .file-upload-progress {
          display: flex;
          flex-direction: row;
          align-items: center;
          ::v-deep .van-progress {
            flex: 1;
          }
          ::v-deep .van-progress__pivot {
            display: none;
          }
          span {
            font-size: 13px;
            font-weight: 500;
            color: #999999;
            padding-left: 8px;
          }
        }
      }
    }
  }
  .basic-info-box{
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 5px;
    margin: 0 3vw;
    width: 94vw;
  }
  ::v-deep .title-font.van-cell{
    color: #666666;
  }
  .upload-border-class{
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 5px;
    width: 94vw;
    margin: 0 3vw;
    text-align: right;

    .text-upload{
      color: #1D84FF;
      font-size: 14px;
    }
  }
  .complain-class{
    padding: 2vw 3vw;
    height: 10vw;
    .complain-item{
      width: 25vw;
    }
  }
  .input-border-class{
    background: #FFFFFF;
    border: 1px solid #DFDFDF;
    border-radius: 5px;
    width: 94vw;
    text-align: center;
    margin: 0 3vw;
  }
  .textarea-border-class{
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 5px;
    width: 94vw;
    text-align: center;
    margin: 0 3vw;
  }
  ::v-deep .van-field__control{
    color: #999999;
  }
  .submit-btn {
    background: #1d84ff;
    box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    height: 44px;
    border: 1px solid transparent;
    width: 94vw;
    margin: 10px 3vw 0 3vw;
  }
  .code-tips {
    font-size: 14px;
    font-weight: 500;
    color: #ff2323;
    padding: 8px 16px;
    position: absolute;
  }
  ::v-deep .van-cell {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  ::v-deep .van-field__label {
    width: 70px;
    margin-right: 0px;
  }
}
</style>
